import React from 'react';
import { EnvelopeSimple, MapPin, PhoneCall } from '@phosphor-icons/react';
import PublicSiteLayout from '../components/PublicSiteLayout';

export default function PublicContactPage() {
  return (
    <PublicSiteLayout>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid lg:grid-cols-[0.95fr_1.05fr] gap-8">
          <div className="bg-[#1E3F2D] text-white rounded-[30px] p-8 shadow-sm">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-white/60">Contact Us</p>
            <h1 className="mt-4 text-4xl font-extrabold tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Reach out for product questions or support.
            </h1>
            <p className="mt-5 text-white/75 leading-8">
              This is a static public contact page for the site. You can replace the sample details below with your actual business contact information at any time.
            </p>

            <div className="mt-8 space-y-4">
              <ContactRow icon={EnvelopeSimple} label="Email" value="spellinnovation@gmail.com" />
              <ContactRow icon={PhoneCall} label="Phone" value="+977-015910781" />
              <ContactRow icon={MapPin} label="Address" value="Old Baneshwor, Kathamandu" />
            </div>
          </div>

          <div className="bg-white border border-[#E8E6E1] rounded-[30px] p-8 shadow-sm">
            <h2 className="text-2xl font-bold text-[#1C1B1A]">Send a Message</h2>
            <p className="mt-2 text-sm text-[#5C5A56]">Static contact form layout for the public site.</p>

            <form className="mt-6 space-y-5">
              <div className="grid md:grid-cols-2 gap-4">
                <Field label="Full Name" placeholder="Your name" />
                <Field label="Email" placeholder="you@example.com" type="email" />
              </div>
              <Field label="Subject" placeholder="How can we help?" />
              <div>
                <label htmlFor="public-contact-message" className="block text-xs font-bold uppercase tracking-[0.18em] text-[#5C5A56] mb-2">Message</label>
                <textarea
                  id="public-contact-message"
                  name="message"
                  rows="6"
                  className="w-full bg-white border border-[#E8E6E1] text-[#1C1B1A] rounded-2xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#1E3F2D]/20 focus:border-[#1E3F2D] transition-all resize-none"
                  placeholder="Write your message here"
                />
              </div>
              <button
                type="button"
                className="inline-flex items-center justify-center px-6 py-3 rounded-2xl bg-[#1E3F2D] text-white font-semibold hover:bg-[#29563E] transition-colors"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
    </PublicSiteLayout>
  );
}

function ContactRow({ icon: Icon, label, value }) {
  return (
    <div className="flex items-center gap-4">
      <div className="w-11 h-11 rounded-2xl bg-white/10 flex items-center justify-center">
        <Icon size={20} weight="fill" className="text-white" />
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.16em] text-white/55">{label}</p>
        <p className="text-sm font-semibold text-white">{value}</p>
      </div>
    </div>
  );
}

function Field({ label, placeholder, type = 'text' }) {
  const id = `public-contact-${label.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div>
      <label htmlFor={id} className="block text-xs font-bold uppercase tracking-[0.18em] text-[#5C5A56] mb-2">{label}</label>
      <input
        id={id}
        name={id}
        type={type}
        className="w-full bg-white border border-[#E8E6E1] text-[#1C1B1A] rounded-2xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#1E3F2D]/20 focus:border-[#1E3F2D] transition-all"
        placeholder={placeholder}
      />
    </div>
  );
}
